import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from '@tanstack/react-router';
import React from 'react';

interface AnnexButtonProps {
  icon: React.ReactNode;
  label: string;
  to?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function AnnexButton({ icon, label, to, onClick }: AnnexButtonProps) {
  const content = (
    <Stack
      alignItems="center"
      spacing={0.5}
      sx={{
        color: 'primary.main',
        textDecoration: 'none',
        opacity: 0.7,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
          opacity: 1,
          transform: 'scale(1.1)',
        }
      }}
    >
      {icon}
      <Typography variant="caption" sx={{ fontSize: '0.6rem', fontWeight: 700 }}>
        {label}
      </Typography>
    </Stack>
  );

  if (to) {
    return (
      <Box component={Link} to={to} onClick={(e) => e.stopPropagation()} sx={{ textDecoration: 'none' }}>
        {content}
      </Box>
    );
  }

  return (
    <Box onClick={onClick}>
      {content}
    </Box>
  );
}
